<template>
  <section>
    <section class="mb-4" v-if="resumenPaciente">
      <h5 class="section-title">Información del paciente</h5>
      <ul class="resumen-list">
        <li><strong>Identificación:</strong> {{ resumenPaciente.identificacion }}</li>
        <li><strong>Nombres:</strong> {{ resumenPaciente.nombres }}</li>
        <li v-if="resumenPaciente.edad"><strong>Edad:</strong> {{ resumenPaciente.edad }}</li>
      </ul>
    </section>

    <section class="mb-4" v-if="resumenPaquete">
      <h5 class="section-title">Información del paquete</h5>
      <ul class="resumen-list">
        <li><strong>Nombre:</strong> {{ resumenPaquete.nombre }}</li>
        <li v-if="resumenPaquete.precio"><strong>Precio:</strong> {{ resumenPaquete.precio }}</li>
      </ul>
    </section>

    <section class="mb-4" v-if="resumenServicios.length">
      <h5 class="section-title">Servicios</h5>
      <div v-for="servicio in resumenServicios" :key="servicio.key" class="mb-3">
        <p class="font-weight-bold mb-1">{{ servicio.title }}:</p>
        <ul class="resumen-list">
          <li v-for="(item, idx) in servicio.items" :key="`${servicio.key}-${idx}`">- {{ item }}</li>
        </ul>
      </div>
    </section>

    <section v-if="resumenDocumentos.length">
      <h5 class="section-title">Documentación</h5>
      <ul class="resumen-list">
        <li v-for="documento in resumenDocumentos" :key="documento.key">
          <strong>{{ documento.label }}:</strong>
          <template v-if="documento.disponible">
            <b-link href="#" @click.prevent="$emit('ver-documento', documento)">Ver documento</b-link>
          </template>
          <template v-else>-</template>
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'ResumenAsignacionPaquete',
  components: { BLink },
  props: {
    resumenPaciente: { type: Object, default: null },
    resumenPaquete: { type: Object, default: null },
    resumenServicios: { type: Array, default: () => [] },
    resumenDocumentos: { type: Array, default: () => [] },
  },
}
</script>

<style scoped>
.section-title {
  font-size: 1.1rem;
  color: #0080c9;
}

.resumen-list {
  list-style: none;
  padding-left: 0;
}

.resumen-list li + li {
  margin-top: 0.5rem;
}
</style>
